import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import DataReactTable from '../MedicalOrders/DataReactTable';
import ReactTableActionsMedics from '../MedicalOrders/ReacTableActionsMedics';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { faVial, faStethoscope, faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Pharmacological extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionAilment: {},
            showCommentaties: [],
            commentaries: [],
            openMedicaments: false,
            loadMedicaments: false,
            useMediTable: false,
            medicament: [],
            dataMedicaments: [],
            openModal: false,
            load: true,
            dataDiagnostic: [],
            diagnostic: [],
            showTable: true,
            vacuna: "",
            principioactivo: "",
            concentracion: "",
            viaadministracion: "",
            observation: "",
            frecuencia: "",
            dateStart: null,
            dateEnd: null,
            firstCharge: false,
            formafarmaceutica:""
        }
    }

    componentDidMount() {
        /* let savedFormulas = this.props.sectionAilment.pharmacological.farmacologico.table;
        if (!!savedFormulas) {
            console.log('1savedFormulas', savedFormulas, savedFormulas.length);
            savedFormulas.forEach(med => this.props.handlerFormulasNewFunctional(med));
        } */
        //this.loadMedicalOrdersLocal();
    }

    loadMedicalOrdersLocal = () => {
        var data = {
            id_historia: this.props.id_historia,
            id_admision: 0,
        };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'antecedente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.existe) {
                        let pharmacologicBackgroud = data.contenido[0].farmacologicos != null ? data.contenido[0].farmacologicos.farmacologicos[0].farmacologico.table : null;

                        console.log('farmaTable', pharmacologicBackgroud)
                        let comp = pharmacologicBackgroud.map(med => {
                            let formula = {
                                activePrinciple: med.principioactivo,
                                concentration: med.concentracion,
                                pharmaceuticalForm: '',
                                route: med.viaadministracion,
                                dose: med.dosis,
                                frequency: med.frecuencia,
                                duration: '30',
                                units: this.durationTable(30, parseInt(med.dosis), this.frecuencyLetters(med.frecuencia))
                            };
                            this.props.handlerFormulasNewFunctional(formula);
                            return formula
                        })
                        //comp.forEach(form => handlerFormulasNew(form));

                        /* let oldFormulas = dataToTableFormula;
                        let newFormulas = [...oldFormulas, ...comp]
                        const uniqueFormulas = [];

                        const unique = newFormulas.filter(element => {
                            const isDuplicate = uniqueFormulas.find(formu => formu.activePrinciple === element.activePrinciple);

                            if (!isDuplicate) {
                                uniqueFormulas.push(element);
                                return true;
                            }

                            return false;
                        });
                        setDataToTableFormula(unique);
                        console.log('unique', unique); */
                        resolve(false);
                    } else {
                        console.log(data.contenido);
                        resolve(false);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        })
    }

    durationTable = (dur, dos, freq) => {
        let valor = (dos * freq) * dur;
        return valor;
    }

    frecuencyLetters = (freq) => {
        switch (freq) {
            case "Dos veces al día":
                return 2
            case "Tres veces al día":
                return 3
            case "Cuatro veces al día":
                return 4
            default:
                return 1
        }
    };

    no_op = () => { }
    sendToMedicalOreders = (formula) => {
        console.log({formula})
        let monthDays = !!this.state.dateStart ? moment(this.state.dateStart).daysInMonth() : 30;
        let units = parseInt(monthDays) * parseInt(this.state.dosis);
        let formulaToSend = {
            activePrinciple: formula.principioactivo,
            concentration: formula.concentracion,
            pharmaceuticalForm: formula.formafarmaceutica,
            route: formula.viaadministracion,
            dose: formula.dosis,
            frequency: formula.frecuencia.toString(),
            duration: monthDays.toString(),
            units: units.toString()
        }
        this.props.handlerFormulasNewFunctional(formulaToSend);
    }

    render() {
        const row = {};

        const reactTableMedicaments = {
            tableHeaderData: [{
                Header: 'Principio activo',
                accessor: 'principioactivo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Producto',
                accessor: 'producto',
            },
            {
                Header: 'Forma Farmacéutica',
                accessor: 'formafarmaceutica',
            },
            {
                Header: 'Codigo',
                accessor: 'atc',
            },
            ],
            tableRowsData: this.state.dataMedicaments
        };

        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset"  >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Farmacologicos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerPharmacologicalBackgroundRadio(e.target.value, 'farmacologico');
                                        }}
                                        row aria-label="position"
                                        id="radio-pharmacological-farmacologico"
                                        name="radio-pharmacological-farmacologico"
                                        value={this.props.sectionAilment.pharmacological.farmacologico.value}
                                    >
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                               {/*  <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.pharmacological.farmacologico.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.pharmacological.farmacologico.comentario}
                                    onChange={(e) => {
                                        this.props.handlerPharmacologicalBackgroundText(e.target.value, 'farmacologico');
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                /> */}
                            </div>
                        </div>
                    </Col>
                </Row>

                {this.props.sectionAilment.pharmacological.farmacologico.value === "Si" ?
                    <Row>
                        <div className="table-medicine-add">
                            <table className="table table--bordered" >
                                <thead>
                                    <tr>
                                        <td>Buscar </td>
                                        <td >Principio Activo</td>
                                        <td >Concentración </td>
                                        <td >Vía de Administración </td>
                                        <td >Dosis </td>
                                        <td >Frecuencia </td>
                                        <td >Fecha Inicio </td>
                                        <td >Fecha Fin </td>
                                        <td ></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Tooltip title="Buscar"
                                                disabled={this.props.stateClinicHistory}
                                            >
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        this.setState({ openMedicaments: true });
                                                    }}>
                                                    <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                        <td >
                                            <TextField
                                                required
                                                type="text"
                                                className="table-medice-fields wider-field-principle"
                                                disabled={this.props.stateClinicHistory}
                                                value={this.state.principioactivo}
                                                onChange={(event) => {
                                                    this.setState({ principioactivo: event.target.value })
                                                }}
                                            />
                                        </td>
                                        <td >
                                            <TextField
                                                required
                                                type="text"
                                                className="table-medice-fields"
                                                disabled={this.props.stateClinicHistory}
                                                value={this.state.concentracion}
                                                onChange={(event) => {
                                                    this.setState({ concentracion: event.target.value })
                                                }}
                                            />
                                        </td>
                                        <td ><TextField
                                            required
                                            type="text"
                                            className="table-medice-fields"
                                            disabled={this.props.stateClinicHistory}
                                            value={this.state.viaadministracion}
                                            onChange={(event) => {
                                                this.setState({ viaadministracion: event.target.value })
                                            }}
                                        /> </td>
                                        <td >
                                            <TextField
                                                required
                                                type="number"
                                                disabled={this.props.stateClinicHistory}
                                                InputProps={{ inputProps: { min: 0, max: 700 } }}
                                                className="table-medice-fields"
                                                value={this.state.dosis}
                                                onChange={(event) => {
                                                    this.setState({ dosis: event.target.value });
                                                }}
                                            />
                                        </td>
                                        <td >
                                            <TextField
                                                className="table-medice-fields wider-field-frequency"
                                                style={{ maxWidth: '100px' }}
                                                disabled={this.props.stateClinicHistory}
                                                value={this.state.frecuencia}
                                                select
                                                onChange={(event) => {
                                                    this.setState({ frecuencia: event.target.value.toString() });
                                                }}
                                            >
                                                <MenuItem className="material-form__option" key={0} value={'Cada 4 horas'}>Cada 4 horas</MenuItem>
                                                <MenuItem className="material-form__option" key={0} value={'Cada 8 horas'}>Cada 8 horas</MenuItem>
                                                <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                                                <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                                                <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                                                <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                                                <MenuItem className="material-form__option" key={4} value={'Una vez a la semana'}>Una vez a la semana</MenuItem>
                                                <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                                                <MenuItem className="material-form__option" key={5} value={'Una vez al mes'}>Una vez al mes</MenuItem>
                                                <MenuItem className="material-form__option" key={6} value={'Una cada dos meses'}>Una cada dos meses</MenuItem>
                                                <MenuItem className="material-form__option" key={7} value={'Una cada seis meses'}>Una cada seis meses</MenuItem>
                                                <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis unica</MenuItem>
                                            </TextField>
                                        </td>
                                        <td >
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <ThemeProvider theme={defaultMaterialTheme}>
                                                    <DatePicker
                                                        format="DD-MM-YYYY"
                                                        disableFuture
                                                        animateYearScrolling
                                                        value={this.state.dateStart}
                                                        variant="inline"
                                                        autoOk={true}
                                                        disabled={this.props.sectionAilment.pharmacological.farmacologico.value !== "Si" || this.props.stateClinicHistory}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        onChange={(date) => {
                                                            row.fecha_inico = moment(new Date(date)).format('DD-MM-YYYY');
                                                            this.setState({ dateStart: date });
                                                        }}
                                                    />
                                                </ThemeProvider>
                                            </MuiPickersUtilsProvider>
                                        </td>
                                        <td >
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <ThemeProvider theme={defaultMaterialTheme}>
                                                    <DatePicker
                                                        variant="inline"
                                                        value={this.state.dateEnd}
                                                        format="yyyy/MM/DD"
                                                        animateYearScrolling
                                                        autoOk={true} 
                                                        disabled={this.props.sectionAilment.pharmacological.farmacologico.value !== "Si"}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        onChange={(date) => {
                                                            row.fecha_fin = moment(new Date(date)).format('YYYY-MM-DD');
                                                            this.setState({ dateEnd: date });
                                                        }}
                                                    />
                                                </ThemeProvider>
                                            </MuiPickersUtilsProvider>
                                        </td>
                                        <td >
                                            <Tooltip title="Agregar"
                                                disabled={this.props.stateClinicHistory}
                                            >
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        console.log("INFOROW", row)
                                                        row.principioactivo = this.state.principioactivo;
                                                        row.concentracion = this.state.concentracion;
                                                        row.viaadministracion = this.state.viaadministracion;
                                                        row.dosis = this.state.dosis;
                                                        row.fecha_inico = moment(this.state.dateStart).format('YYYY-MM-DD');
                                                        row.fecha_fin = moment(this.state.dateEnd).format('YYYY-MM-DD');
                                                        row.frecuencia = this.state.frecuencia.toString();
                                                        row.formafarmaceutica = this.state.formafarmaceutica

                                                        if (/* Object.keys(row).length !== 0 || this.state.medicament.length !== 0 || */ row.principioactivo !== '' && row.concentracion !== "" && row.dosis !== undefined && row.viaadministracion !== "" && row.frecuencia !== "" && typeof row.fecha_inico !== 'Fecha inválida' && typeof row.fecha_fin !== 'Fecha inválida') {

                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerPharmacologicalBackgroundTableAdd("farmacologico", row);
                                                                this.sendToMedicalOreders(row);
                                                                //this.props.sharedFormulas(row);
                                                                this.setState({
                                                                    dosis: '',
                                                                    principioactivo: '',
                                                                    viaadministracion: "",
                                                                    concentracion: "",
                                                                    frecuencia: '',
                                                                    dateStart: null,
                                                                    dateEnd: null,
                                                                    formafarmaceutica: ''
                                                                })
                                                            });

                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }

                                                    }}
                                                >
                                                    <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    {this.state.showTable ?
                                        this.props.sectionAilment.pharmacological.farmacologico.table.map((data, num) => {
                                            return <tr key={num}>
                                                <td></td>
                                                <td className="wider-field-principle">{data.principioactivo}</td>
                                                <td>{data.concentracion}</td>
                                                <td>{data.viaadministracion}</td>
                                                <td>{data.dosis}</td>
                                                <td className="wider-field-frequency">{data.frecuencia}</td>
                                                <td>{data.fecha_inico !== null && data.fecha_inico !== undefined && data.fecha_inico !== 'Fecha inválida' ? data.fecha_inico : ''}</td>
                                                <td>{data.fecha_fin!== null && data.fecha_fin !== undefined && data.fecha_fin !== 'Fecha inválida' ? data.fecha_fin : ''}</td>
                                                <td>
                                                    <Tooltip title="Quitar"
                                                        disabled={this.props.stateClinicHistory}
                                                    >
                                                        <IconButton
                                                            color="primary"
                                                            onClick={() => {
                                                                this.props.handlerPharmacologicalBackgroundTableDelete("farmacologico", num);
                                                                this.setState({ showTable: true });
                                                            }}>
                                                            <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        })
                                        : null}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                    : null}
                <Row>
                    <div className="form">
                        <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                id="textarea-observation"
                                value={this.props.sectionAilment.pharmacological.observacion}
                                disabled={this.props.stateClinicHistory}
                                name="textarea-surgical"
                                onChange={(e) => {
                                    this.props.handlerPharmacologicalBackgroundObservation(e.target.value, 'observacion');
                                }}
                            >
                            </textarea>
                        </div>
                    </div>
                </Row>
                <Modal
                    open={this.state.openMedicaments}
                    onClose={() => {
                        this.setState({ openMedicaments: false });
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                            <h5 className="bold-text">Medicamentos</h5>
                        </div>
                        <div className="form">
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                    <span className="form__form-group-label">Principio Activo</span>
                                    <div className="form__form-group-field">
                                        <TextField
                                            className="medical-material-form__field"
                                            placeholder="Ingrese un parámetro para iniciar la búsqueda"
                                            style={{ width: '100%' }}
                                            onChange={(e) => {
                                                e.persist();
                                                this.setState({ loadMedicaments: true }, () => {
                                                    this.props.searchMedicaments(e.target.value).then((dataMedicaments) => {
                                                        this.setState({ dataMedicaments: dataMedicaments, loadMedicaments: false })
                                                    })
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            {!this.state.loadMedicaments ?
                                <DataReactTable
                                    title=""
                                    reactTableData={reactTableMedicaments}
                                    config={{
                                        withPagination: true,
                                        withSearchEngine: false,
                                        isSortable: false,
                                        watchCustomMenu: false
                                    }}
                                    ReactTableActions={ReactTableActionsMedics}
                                    Callback={(medicament) => {
                                        console.log("Medicamento", medicament);
                                        this.setState({
                                            medicament: medicament, openMedicaments: false,
                                            principioactivo: medicament.principioactivo, viaadministracion: medicament.viaadministracion,
                                            concentracion: medicament.cantidad + medicament.unidadmedida,
                                            formafarmaceutica: medicament.formafarmaceutica
                                        });
                                    }}
                                /> : <div style={{ margin: 'auto', width: 280, height: 480, display: "flex", justifyContent: 'center', flexDirection: 'column' }}>
                                    <div class="load__icon-wrap">
                                        <svg class="load__icon">
                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                        </svg>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default Pharmacological;
